import { axiosApi } from '@/axios'
import { AxiosResponse } from 'axios'
import {
  Params,
  Paginator,
  City,
  Subregion,
  Region,
  Locality,
  CreateCityDTO,
  Country,
} from '@/utils/interfaces'
import { ApiController } from '@/utils/classes/ApiController'

export const cityController = new ApiController<City, CreateCityDTO>('/cities/')

export const getCities = (
  params?: Params,
): Promise<AxiosResponse<Paginator<City>>> =>
  axiosApi.get('/cities/', { params })

export const getSubregions = (
  params?: Params,
): Promise<AxiosResponse<Paginator<Subregion>>> =>
  axiosApi.get('/subregions/', { params })

export const getRegions = (
  params?: Params,
): Promise<AxiosResponse<Paginator<Region>>> =>
  axiosApi.get('/regions/', { params })

export const getCountries = (
  params?: Params,
): Promise<AxiosResponse<Paginator<Country>>> =>
  axiosApi.get('/countries/', { params })

export const getLocalities = (params?: Params) =>
  axiosApi.get<Paginator<Locality>>('/localities/', { params })
